export default {
  title: {
    notes: 'Title of punchout dialog',
    message: 'Punchout',
  },
  items: {
    subTitle: {
      notes: 'Subtitle of punchout items',
      message: 'Items',
    },
  },
  infoSection: {
    subTitle: {
      notes: 'Subtitle of information section',
      message: 'Punchout information',
    },
    subtotal: {
      notes: 'Name of field "Subtotal" for a punchout',
      message: 'Subtotal',
    },
    address: {
      notes: 'Name of field "Address" for a punchout',
      message: 'Punchout address',
    },
  },
  submit: {
    notes: 'Text on button submitting the punchout',
    message: 'Submit punchout',
    notification: {
      notes:
        'Notification toast viewed when submitting the punchout, to SAP Ariba, or any other eProcurement system',
      message: 'Submitting punchout and redirecting to the eProcurement system',
    },
  },
  remove: {
    notes: 'Text on button for removing an active punchout',
    message: 'Remove punchout',
  },
};
